import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHospitalBoard = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-0.5 -0.5 25 25",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18,9.75H14.25V6a.75.75,0,0,0-.75-.75h-3A.75.75,0,0,0,9.75,6V9.75H6a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H9.75V18a.75.75,0,0,0,.75.75h3a.75.75,0,0,0,.75-.75V14.25H18a.75.75,0,0,0,.75-.75v-3A.75.75,0,0,0,18,9.75Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})]
});
export default SvgHospitalBoard;
